import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=a30747ee&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import "./PageHeader.vue?vue&type=style&index=0&id=a30747ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30747ee",
  null
  
)

export default component.exports